export default __webpack_public_path__ + "static/media/MasterUpload.59b820ca.xlsx";